/* Carries a Stone Match "for someone else" into the cart, from wherever the
   buyer ends up adding.

   Loaded on every page on purpose. The gift context has to survive the buyer
   leaving the result page through "Explore Shop" and adding something the Match
   never recommended — that is still a gift, and scoping this to the result page
   (as it first was) silently dropped every one of those.

   What it writes is the context, not the decision. The cart's `This is a gift`
   checkbox is the only place the buyer decides, and it reads `Gift` back from
   here as its default. Writing at add time rather than leaving it in
   sessionStorage is what makes that default survive a closed tab: the cart
   remembers, the browser does not have to. */
(() => {
  const ROOT = window.Shopify?.routes?.root || '/';
  const CART_LINES_UPDATE_EVENT = 'shopify:cart:lines-update';

  function giftContext() {
    try {
      const context = JSON.parse(sessionStorage.getItem('fsStoneMatchGiftContext') || 'null');
      return context && context.mode === 'gift' ? context : null;
    } catch (error) {
      return null;
    }
  }

  // The order attribute carries the whole printed block, not just the sentence.
  // What was printed is the order fact, and the state line is printed too —
  // rebuilding it at fulfilment from a key would reintroduce exactly the
  // derivation the freeze rule exists to prevent.
  function printBlock(context) {
    if (!context.print_copy) return '';
    return context.state_label
      ? `${context.state_label.toUpperCase()}\n\n${context.print_copy}`
      : context.print_copy;
  }

  async function carryContextToCart() {
    const context = giftContext();
    if (!context) return;

    // Never overwrite a decision the buyer has already made in the cart. Someone
    // who unchecked the box and then added a second piece should not find it
    // checked again.
    let cart = null;
    try {
      cart = await (await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })).json();
    } catch (error) {
      return;
    }
    if (cart?.attributes?.Gift) return;

    const block = printBlock(context);
    try {
      await fetch(`${ROOT}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          attributes: {
            Gift: 'Yes',
            'Include Stone Match': block ? 'Yes' : 'No',
            __fs_stone_match_result_id: context.result_id || '',
            __fs_stone_match_state_key: context.state_key || '',
            __fs_stone_match_print_copy: block,
            __fs_stone_match_copy_version: context.copy_version || '',
          },
        }),
      });
    } catch (error) {
      // A failed write must not break the add. The piece is still in the cart and
      // the buyer can tick `This is a gift` there by hand.
      console.warn('[fs-gift] could not carry the Stone Match context to the cart:', error);
    }
  }

  document.addEventListener(CART_LINES_UPDATE_EVENT, (event) => {
    if (event.action !== 'add') return;
    const settled = event.promise ? Promise.resolve(event.promise).catch(() => null) : Promise.resolve(null);
    settled.then(carryContextToCart);
  });
})();
